import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/employeeSlice';


export default function EmployeeProtectedRoutes() {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.employee);
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem('token');
    const role =  JSON.parse(localStorage.getItem('user'))?.role;
    if (!token || !isAuthenticated || role !== 'employee') {
      dispatch(logout())
      navigate('/employee-login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
